import { Link, useParams } from "react-router-dom";
import { news, newsMap } from "@/mocks/news";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function NewsDetail() {
  const { id } = useParams();
  const article = id ? newsMap[id] : undefined;

  if (!article) {
    return (
      <div className="px-4 md:px-8 py-16">
        <div className="mx-auto flex max-w-lg flex-col items-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-14 text-center">
          <i className="ri-error-warning-line text-4xl text-accent-500" />
          <h1 className="mt-3 font-heading text-xl font-bold text-foreground-950">新闻不存在</h1>
          <p className="mt-2 text-sm text-foreground-500">该资讯可能已被移除，请返回新闻列表浏览其他内容。</p>
          <Link
            to="/news"
            className="mt-5 inline-flex items-center gap-1 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            <i className="ri-arrow-left-line" /> 返回新闻列表
          </Link>
        </div>
      </div>
    );
  }

  const related = news.filter((n) => n.id !== article.id && n.category === article.category).slice(0, 3);

  return (
    <div className="px-4 md:px-8 py-6 md:py-8">
      <Breadcrumb items={[{ label: "新闻资讯", to: "/news" }, { label: article.category }]} />

      <article className="mx-auto mt-5 max-w-3xl">
        <span className="rounded bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-800">{article.category}</span>
        <h1 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{article.title}</h1>
        <p className="mt-3 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1"><i className="ri-user-line" /> {article.author}</span>
          <span className="flex items-center gap-1"><i className="ri-time-line" /> {article.date}</span>
        </p>

        <div className="mt-5 h-64 w-full overflow-hidden rounded-lg bg-background-200 md:h-80">
          <img src={article.image} alt={article.title} title={`${article.title} - NBA直播资讯`} className="h-full w-full object-top" />
        </div>

        <p className="mt-6 text-base leading-loose text-foreground-800">{article.content}</p>

        <div className="mt-6 flex flex-wrap gap-2">
          {article.tags.map((tag) => (
            <span key={tag} className="rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-600">#{tag}</span>
          ))}
        </div>
      </article>

      {related.length > 0 && (
        <section className="mx-auto mt-12 max-w-3xl">
          <h2 className="mb-4 font-heading text-xl font-bold text-foreground-950">相关资讯</h2>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {related.map((item) => (
              <Link
                key={item.id}
                to={`/news/${item.id}`}
                className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="h-28 w-full overflow-hidden bg-background-200">
                  <img src={item.image} alt={item.title} title={`${item.title} - NBA直播资讯`} className="h-full w-full object-top" />
                </div>
                <p className="line-clamp-2 p-3 text-sm font-medium text-foreground-800 group-hover:text-primary-600">{item.title}</p>
              </Link>
            ))}
          </div>
        </section>
      )}

      <div className="mx-auto mt-10 max-w-3xl">
        <Link
          to="/news"
          className="inline-flex items-center gap-1 rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-700 whitespace-nowrap transition-colors hover:bg-background-100"
        >
          <i className="ri-arrow-left-line" /> 返回新闻列表
        </Link>
      </div>
    </div>
  );
}